const rootState = state => (!!state && state.variantFilter) || {};


export default rootState;